export default __webpack_public_path__ + "static/media/bedroom3.aeae84a1.webp";